import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';

export const DesktopWrapper = styled.div<{ $marginTop?: boolean }>`
  display: block;
  margin-top: ${({ $marginTop }) => ($marginTop ? spacing.space40 : 0)};

  @media (max-width: ${breakpoints.m}) {
    display: none;
  }
`;
